import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

class PlayerCharacterList extends Component {
    render() {
        let data = this.props.data;
        
        let characters = [];

        if (data) {
            for(let char_i in data["characters"]) {
                let char = data["characters"][char_i];
                let alt = data["character_alts"][char];
                characters.push(<li key={char}><img src={getCharFilename(char, alt, "blue")} alt={char} /></li>);
            }
        }
        
        return (
            <ul className="characters">
              {characters}
            </ul>
        );
    }
}

export default PlayerCharacterList;
